import { relations } from 'drizzle-orm'
import { bigint, jsonb, pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import { getBaseFields, getBaseIndexes, getIdReference } from '../common/utils'
import { users } from './user'

export const activityTypeEnum = pgEnum('activity_type', [
  'note',
  'call',
  'email',
  'meeting',
  'stage_change',
  'task_status',
])

export const activities = pgTable(
  'activities',
  {
    ...getBaseFields(),
    entityType: text().notNull(),
    entityId: bigint({ mode: 'number' }).notNull(),
    type: activityTypeEnum().notNull(),
    subject: text().notNull(),
    content: text(),
    userId: getIdReference(() => users.id),
    metadata: jsonb(),
  },
  (table) => getBaseIndexes('activities', table),
)

export const activitiesRelations = relations(activities, ({ one }) => ({
  user: one(users, {
    fields: [activities.userId],
    references: [users.id],
  }),
}))
